
// async function lookupCertificate() {
//     const reportNo = document.getElementById('reportno').value;
//     const resultDiv = document.getElementById('result');

//     const pattern = /^(\d+-?\d+|[a-zA-Z0-9]{4,5})$/;
//     if (!pattern.test(reportNo) || reportNo.length <= 4 || reportNo.length > 14) {
//         resultDiv.classList.remove('d-none');
//         resultDiv.innerHTML = '<div class="alert alert-danger">Invalid report number. Please enter a valid number.</div>';
//         return;
//     }

//     const product = await createProductObject(reportNo);
    
//     resultDiv.classList.remove('d-none');
//     if (product) {
//         resultDiv.innerHTML = `
//             <div class="alert alert-success">
//                 <h4>Certificate Found</h4>
//                 <pre>${JSON.stringify(product, null, 2)}</pre>
//             </div>`;
//     } else {
//         resultDiv.innerHTML = '<div class="alert alert-danger">No certificate found or an error occurred.</div>';
//     }
// }
async function createProductObject(diamond_id) {
    let url = window.API_URL + `diamonds/single/authenticity/certificate/${diamond_id}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const product = await response.json();
      console.log(product);
        return product;
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}
 const input = document.getElementById("reportno");
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        lookupCertificate();
      }
    });
async function lookupCertificate() {
    const reportNo = document.getElementById('reportno').value;
    const resultDiv = document.getElementById('result');

    const pattern = /^(\d+-?\d+|[a-zA-Z0-9]{4,5})$/;
    if (!pattern.test(reportNo) || reportNo.length <= 4 || reportNo.length > 14) {
        resultDiv.classList.remove('d-none');
        resultDiv.innerHTML = '<div class="alert alert-danger">Invalid report number. Please enter a valid number.</div>';
        return;
    }

    const product = await createProductObject(reportNo);
      console.log(product.message);
    resultDiv.classList.remove('d-none');
    resultDiv.innerHTML = ''; // Clear old content

    if (product.message != "PDF not found .") {
    
        // Define your full HTML template as a JS template literal
        const certificateHTML = `
         <div class="pdp-header">
        <a class="button pdf-download" href="https://dsv7iunirnrax.cloudfront.net/authenticity/cert_${product.id || ''}.pdf" target="_blank">Download Report PDF</a>
          </div>
          <div class="main_div product_detail">
         
            <table class='dash_border'>
              <tbody>
                <tr>
                  <td>
                    <img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/certificate-of-authenticity_logo.png?v=1736835666" style="width: 250px;">
                  </td>
                  <td>
                    <img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/image_2024_11_22T05_08_58_400Z.png?v=1732611025" alt="True Sanity" style="width: 250px;">
                  </td>
                </tr>
                <tr>
            <td>
                <h4 style="font-weight: 600;">${product.product_title || ''}</h4>
            </td>
          </tr>
                <tr>
                  <td>
                    <h4 style="font-weight: 600;">DETAILS:</h4>
                    <p>${product.center_gemstone || product._2_type}</p> 
                  </td>
                  <td>
                    <p style="margin-top: 18px;">Metal: ${product.metal || product._2_metal}</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <table style="margin: 30px 0;" class='dash_border'>
              <tbody>
                <tr>
                    ${product.type_1 ? ( `
                  <td rowspan="3" style="border-bottom: 1px dashed black; border-top: 1px dashed black; padding: 30px 0; vertical-align: top;">
                    <h5 style="font-weight: 600;">Stone Details:</h5><br>
                    <span>Type: ${product.type_1 || 'NA'}</span><br> 
                    <span>Dimensions: ${product.dimension || 'NA'}</span><br>
                    <span>Shape: ${product.shape_1 || 'NA'}</span><br>
                    <span>Carat: ${product.minimum_carat_weight_1 || 'NA'}</span><br>
                    <span>Number: ${product.No_of_stone_1 || 'NA'}</span><br>
                    <span>Color: ${product.color_1 || 'NA'}</span><br>
                    <span>Quality: ${product.clarity_1 || 'NA'}</span><br>
                    <span>Treatment: ${product.treatment_1 || 'NA'}</span><br>
                    <span>Origin: ${product.origin_1 || 'NA'}</span>
                 </td>` ) : ''}
               ${product.type_2 ? ( `
                  <td style="border-top: 1px dashed black; padding: 30px 0;">
                    <h5 style="font-weight: 600;">Accent Stone Details</h5><br>
                    <h5 style="font-weight: 600;">Stone Details 1:</h5>
                    <span>Type: ${product.type_2 || 'NA'}</span><br> 
                    <span>Shape: ${product.shape_2 || 'NA'}</span><br> 
                    <span>Accent carat: ${product.minimum_carat_weight_2 || 'NA'}</span><br>
                    <span>Number: ${product.No_of_stone_2 || 'NA'}</span><br> 
                    <span>Color: ${product.color_2  || 'NA'}</span><br>
                    <span>Clarity: ${product.clarity_2 || 'NA'}</span><br> 
                    <span>Origin: ${product.origin_2 || 'NA'}</span><br>
                  </td>` ) : ''}
             ${product.type_3 ? ( `
                  <td style="border-top: 1px dashed black; padding: 30px 0;"><br><br>
                    <h5 style="font-weight: 600;">Stone Details 2:</h5>
                    <span>Type: ${product.type_3 || 'NA'}</span><br>
                    <span>Shape: ${product.shape_3 || 'NA'}</span><br>
                   <span>Accent carat: ${product.minimum_carat_weight_3 || 'NA'}</span><br>
                    <span>Number: ${product.No_of_stone_3 || 'NA'}</span><br>
                    <span>Color: ${product.color_3 || 'NA'}</span><br>
                    <span>Clarity: ${product.clarity_3 || 'NA'}</span><br> 
                    <span>Treatment: ${product.treatment_3 || 'NA'}</span><br> 
                    <span>Origin: ${product.origin_3 || 'NA'}</span><br>
                  </td>
                </tr> `  ) : ''}

                <tr>
                ${product.type_4 ? (
                  `<td style="border-bottom: 1px dashed black; padding: 30px 0;">
                    <h5 style="font-weight: 600;">Stone Details 3:</h5>
                    <span>Type: ${product.type_4 || 'NA'}</span><br>
                    <span>Shape: ${product.shape_4 || 'NA'}</span><br>
                    <span>Accent carat: ${product.minimum_carat_weight_4 || 'NA'}</span><br>
                    <span>Number: ${product.No_of_stone_4 || 'NA'}</span><br>
                    <span>Color: ${product.color_4 || 'NA'}</span><br>
                    <span>Clarity: ${product.clarity_4 || 'NA'}</span><br> 
                    <span>Treatment: ${product.atreatment_4 || 'NA'}</span><br> 
                    <span>Origin: ${product.origin_4 || 'NA'}</span><br> 
                  </td>`
                ) : ''}
            ${product.type_5 ? (
                  `<td style="border-bottom: 1px dashed black; padding: 30px 0;">
                    <h5 style="font-weight: 600;">Stone Details 4:</h5>
                    <span>Type: ${product.type_5 || 'NA'}</span><br>
                    <span>Shape: ${product.shape_5 || 'NA'}</span><br>
                    <span>Accent carat: ${product.minimum_carat_weight_5 || 'NA'}</span><br>
                    <span>Number: ${product.No_of_stone_5 || 'NA'}</span><br>
                    <span>Color: ${product.color_5 || 'NA'}</span><br>
                    <span>Clarity: ${product.clarity_5 || 'NA'}</span><br> 
                    <span>Treatment: ${product.treatment_5 || 'NA'}</span><br> 
                    <span>Origin: ${product.origin_5 || 'NA'}</span><br> 
                  </td>`
                   ) : ''}
                </tr>


            
              <tr>
              ${product._2_certification_number ? ( `
                  <td  style="border-bottom: 1px dashed black; border-top: 1px dashed black; padding: 30px 0; vertical-align: top;">
                  <span>SKU Number: ${product._2_number || 'NA'}</span><br> 
                  <span>Metal: ${product._2_metal || 'NA' }</span><br>
                  <span>Chain Length: ${product._2_chain_length || 'NA'}</span><br>
                  <span>Estimated Product Delivery Date by True: ${product._2_product_devivery_date || 'NA'}</span><br>
                  </td>` ) : ''}
               ${product._2_certification_number ? ( `
                  <td style="border-top: 1px dashed black; padding: 30px 0;">
                  <span>Shape: ${product._2_shape || 'NA'}</span><br> 
                  <span>Type: ${product._2_type || 'NA'}</span><br> 
                  <span>Number: ${product._2_number || 'NA'}</span><br> 
                  <span>Color: ${product._2_color || 'NA'}</span><br>
                  <span>Stone Clarity: ${product._2_stone_clarity || 'NA'}</span><br> 
                  <span>Stone Carat: ${product._2_stone_carat || 'NA'}</span><br> 
                  <span>Stone Treatment: ${product._2_stone_treatment || 'NA'}</span><br>
                  </td>` ) : ''}
               
                    </tr> 

                <tr>
             
                ${product._2_certification_number ? (
                  `<td style="border-bottom: 1px dashed black; padding: 30px 0;">
                  <span>Reference Number: ${product._2_reference_number || 'NA'}</span><br>
                  <span>Weight: ${product._2_weight || 'NA'}</span><br>
                  <span>Measurements: ${product._2_measurement || 'NA'}</span><br>
                  <span>Color: ${product._2_color_2 || 'NA'}</span><br>
                  <span>Clarity: ${product._2_stone_clarity || 'NA'}</span><br>
                  <span>Certification No#: ${product._2_certification_number || 'NA'}</span><br> 
                  <span>Treatment: ${product._2_stone_treatment || 'NA'}</span><br> 
                  <span>Estimated Stone Delivery Date by Gem R You (HK) Ltd: ${product._2_stone_devivery_date || 'NA'}</span><br> 
                  </td>`
                  ) : ''}
           
                ${product._2_certification_number ? (
                  `<td style="border-bottom: 1px dashed black; padding: 30px 0;">
                  <span>Table: ${product._2_table || 'NA'}</span><br>
                  <span>Depth: ${product._2_depth || 'NA'}</span><br>
                  <span>Symmetry: ${product._2_symmetry || 'NA'}</span><br>
                  <span>Polish: ${product._2_polish || 'NA'}</span><br>
                  <span>Fluorescence Intensity: ${product._2_fluorescence_intensity || 'NA'}</span><br>
                  <span>Ration: ${product._2_ratio || 'NA'}</span><br>
                  </td>`
                  ) : ''}
                </tr>
              </tbody>
            </table>

            <table style="margin-top:0;">
              <tbody>
                <tr>
                  <td>
                    <img src="${product.image_url || ""}" style="width: 250px;">
                  </td>
                  <td>
                    <h4 style="font-weight: 600;">TRUE SANITY REPORT: ${product.cad_number || ''}</h4><br>
                    <p>At TrueSanity, all gemstones featured on TrueSanity.com have been thoroughly examined and authenticated by our expert gemologists.</p>
                    <table style="margin-top:0;">
                      <tbody>
                        <tr>
                          <td style="text-align: center;">
                            <img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/certificate-of-authenticity_logo_2.png?v=1736835684" alt="True Sanity" style="width: 100px;" class="certificate_logo">
                          </td>  
                          <td style="text-align: center;">
                          <div id="qrcode"></div>
                          </td> 
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        `;

        // Append to result div
        resultDiv.insertAdjacentHTML('beforeend', certificateHTML);
  

    //  Then safely generate QR code
    const myURL = product.product_url || '';
    const qrDiv = document.getElementById("qrcode");
    if (myURL && qrDiv) {
      new QRCode(qrDiv, {
        text: myURL,
        width: 160,
        height: 160
      });
    }
      // Pdf download link 
//       const certificateNumber = product._2_certification_number || '';
// if (certificateNumber) {
//   const downloadLink = document.querySelector('a.button.pdf-download');
//   if (downloadLink) {
//     downloadLink.href = `https://dsv7iunirnrax.cloudfront.net/authenticity/cert_${certificateNumber}.pdf`;
//   }
// }
    } else {
        resultDiv.innerHTML = '<div class="alert alert-danger">No certificate found.</div>';
    }
}
